import React from 'react';
import {
  ElementProps,
  DropdownElementClass,
} from 'types/documentTemplateElement';
import CustomSelect from '../../inputs/CustomSelect';
import {buildLabel, checkError} from '../../../utils/elementUtils';
import {useIsDocumentElementDisabled} from '../../../hooks/useIsDocumentElementDisabled';

interface DropdownElementProps extends ElementProps<DropdownElementClass> {}

const DropdownElementComponent: React.FC<DropdownElementProps> = ({
  element,
  updateElement,
  mode,
}) => {
  const handleChange = (selected: any) => {
    if (mode === 'view' || mode === 'admin') {
      const newValue = element.properties.isMulti
        ? Array.isArray(selected)
          ? selected.map(opt => opt.value)
          : []
        : selected
          ? selected.value
          : '';

      updateElement(
        new DropdownElementClass({
          ...element,
          properties: {...element.properties, value: newValue},
        }),
      );
    }
  };
  const options = element.properties.options.map(opt => ({
    label: opt,
    value: opt,
  }));
  const disabled = useIsDocumentElementDisabled(element, mode);
  const horizontal = !!element.properties.horizontal;
  const containerClass =
    mode === 'view' || mode === 'preview' || mode === 'admin'
      ? element.properties.showLabel
        ? 'w-full mx-3 mb-2'
        : 'w-full mt-[30px] mx-3 mb-2'
      : 'w-full m-8';

  const contentClass = `flex ${horizontal ? 'flex-row items-start gap-3' : 'flex-col gap-[0.625rem]'} w-full`;
  return (
    <div className={containerClass}>
      <div className={contentClass}>
        {element.properties.showLabel && (
          <label
            className={`text-slate-800 text-sm font-semibold font-['Inter'] dark:text-white 
            ${horizontal ? 'w-1/2' : ''}`}>
            {buildLabel(element)}
          </label>
        )}
        <div className={horizontal ? 'w-1/2 flex justify-end' : 'w-full'}>
          <CustomSelect
            options={options}
            error={checkError(element, mode)}
            isMulti={element.properties.isMulti}
            onChange={handleChange}
            value={element.properties.value}
            disabled={disabled}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default DropdownElementComponent;
